// import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"

import withImages from "areas/product/hoc/with-images"
import Button from "components/ui/button"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
  CarouselScrollSnaps,
} from "components/ui/carousel"
// import { retry } from "helpers/application"
import { isVideoView, isJ3dView } from "helpers/gallery-slide-view"
import { getPref } from "helpers/user-prefs"
import { cn } from "styles/utils"

import MagnifyImage from "./magnify-image"
import ProductImage from "./product-image"
import ProductVideo from "./product-video"

// const ProductJ3D = loadable(() => retry(() => import("./product-j3d")), {
//   ssr: false,
// })
// const ProductJ3DV2 = loadable(() => retry(() => import("./product-j3d-v2")), {
//   ssr: false,
// })

const MainImageSlider = ({
  currentSlideIndex,
  dataCyType,
  defaultImage,
  // enableJ3D,
  j3dSlideIndex,
  miniview,
  onImageClick,
  productTitle,
  // showJ3d,
  // showJ3dV2,
  slidesArray,
  trackSlide,
  zoomImg,
}) => {
  const [emblaApi, setEmblaApi] = useState()
  // const showJ3d = useSelector((state) => state.previewImage.j3d)
  // const showJ3dV2 = useSelector((state) => state.previewImage.j3dV2)
  const displayMiniview = useSelector(
    (state) =>
      state.previewImageUI.miniview.show &&
      !state.previewImageUI.miniview.swipeHide &&
      !state.previewImageUI.miniview.scrollHide &&
      !getPref("hide_miniview")
  )

  const pdpPricingHierarchyExp = useSelector(
    (state) => state.experiment.pdpPricingHierarchy.variant_id
  )

  const swipeable =
    miniview ||
    !sl.config.enable_j3d_carousel ||
    (j3dSlideIndex > 0 && slidesArray.length > 1
      ? currentSlideIndex < slidesArray.length - 1
      : true)

  const filteredSlides = slidesArray.filter(
    (slide) => !isJ3dView(slide.view) && (!miniview || !isVideoView(slide.view))
  )

  const onSlideChange = useCallback(() => {
    if (!emblaApi) return
    if (!miniview || displayMiniview) {
      trackSlide(emblaApi.selectedScrollSnap())
    }
  }, [emblaApi, miniview, displayMiniview])

  const scrollTo = useCallback(
    (index) => {
      if (!emblaApi) return
      emblaApi.scrollTo(index)
    },
    [emblaApi]
  )

  useEffect(() => {
    if (!emblaApi) return
    onSlideChange()
    emblaApi.on("select", onSlideChange)
    emblaApi.on("reInit", onSlideChange)

    return () => emblaApi?.off("select", onSlideChange)
  }, [emblaApi, onSlideChange])

  useEffect(() => {
    const slideIndex = miniview
      ? Math.min(
          slidesArray.filter((s) => !isVideoView(s.view) && !isJ3dView(s.view))
            .length - 1,
          currentSlideIndex
        )
      : currentSlideIndex
    scrollTo(slideIndex)
  }, [emblaApi, currentSlideIndex, miniview, slidesArray, scrollTo])

  return (
    <Carousel
      className="tablet:mb-6"
      description="Product Images"
      opts={{ active: swipeable }}
      setApi={setEmblaApi}
    >
      <CarouselContent
        aria-live="polite"
        className="tablet:gap-0 gap-8"
        viewportClassName={cn(
          pdpPricingHierarchyExp === 0 && "tablet:pl-0 pl-10"
        )}
      >
        {!defaultImage && slidesArray.length == 0 && (
          <CarouselItem className="tablet:basis-full relative basis-4/5">
            <ProductImage
              alt="Loading"
              height="1"
              src={require("images/icons/jewlr.gif")}
              width="1"
            />
          </CarouselItem>
        )}
        {filteredSlides.map((slide, index) => (
          <CarouselItem
            aria-label={`Image ${index + 1} of ${filteredSlides.length}`}
            className="tablet:basis-full basis-4/5"
            key={`mainslider-${slide.view}`}
          >
            {isVideoView(slide.view) ? (
              <ProductVideo
                video={slide.src}
                {...{ currentSlideIndex, index }}
              />
            ) : (
              // : isJ3dView(slide.view) ? (
              //   <div
              //     className="tablet:max-h-(--tablet-max-width) tablet:max-w-(--tablet-max-width) desktop:max-h-(--desktop-max-width) desktop:max-w-(--desktop-max-width) mx-auto h-full max-h-full w-full max-w-full"
              //     style={{
              //       "--desktop-max-width": "500px",
              //       "--tablet-max-width": "325px",
              //     }}
              //   >
              //     {typeof window !== "undefined" && enableJ3D && (
              //       <Suspense fallback={<div />}>
              //         {showJ3d && !showJ3dV2 && <ProductJ3D />}
              //         {showJ3dV2 && <ProductJ3DV2 />}
              //       </Suspense>
              //     )}
              //   </div>
              // )
              <>
                {sl.config.enable_pdp_image_zoom ? (
                  <MagnifyImage
                    alt={productTitle}
                    className={`prod-img-${slide.view}`}
                    data-cy={`product-main-slider-main-img-${index}${
                      dataCyType ? `-${dataCyType}` : ""
                    }`}
                    height="325"
                    lazyload={index > 0}
                    mgShowZoom={
                      sl.config.enable_pdp_image_zoom &&
                      currentSlideIndex === index &&
                      zoomImg &&
                      !isVideoView(slide.view)
                      // && !isJ3dView(slide.view)
                    }
                    onClick={
                      onImageClick && currentSlideIndex === index
                        ? onImageClick
                        : undefined
                    }
                    sizes={slide.sizes}
                    src={slide.src}
                    srcSet={slide.srcset}
                    width="325"
                  />
                ) : (
                  <ProductImage
                    alt={productTitle}
                    className={`prod-img-${slide.view}`}
                    data-cy={`product-main-slider-main-img-${index}${
                      dataCyType ? `-${dataCyType}` : ""
                    }`}
                    height="325"
                    lazyload={index > 0}
                    sizes={slide.sizes}
                    src={slide.src}
                    srcSet={slide.srcset}
                    width="325"
                  />
                )}

                {!miniview && slide.view === "tangiblee_view" && (
                  <Button
                    className="js-tangiblee-cta text-14 tablet:left-0 tablet:w-full tablet:transform-none absolute bottom-10 left-1/2 hidden w-11/12 -translate-x-1/2 rounded-sm px-24 py-16"
                    variant="secondary"
                  >
                    TAP TO VIEW SIZE
                  </Button>
                )}
              </>
            )}
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
      <CarouselScrollSnaps className="desktop:hidden" />
    </Carousel>
  )
}

MainImageSlider.propTypes = {
  currentSlideIndex: PropTypes.number,
  dataCyType: PropTypes.string,
  defaultImage: PropTypes.object,
  displayMiniview: PropTypes.bool,
  // enableJ3D: PropTypes.bool,
  j3dSlideIndex: PropTypes.number,
  miniview: PropTypes.bool,
  onImageClick: PropTypes.func,
  productTitle: PropTypes.string,
  slidesArray: PropTypes.array,
  styleCode: PropTypes.string,
  trackSlide: PropTypes.func,
  zoomImg: PropTypes.object,
}

export default withImages(MainImageSlider)
